import Icon, { IconType } from 'components/Icon';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setSidebarVisible, setSidebarDocked, setSidebarHovered } from 'redux/mode/actions';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';

interface SidebarToggleProps {
	isFloating?: boolean;
}

const SidebarToggle = ({ isFloating = false }: SidebarToggleProps) => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const { sidebarVisible, sidebarDocked, isMobile } = useSelector((r: RootReducer) => {
		return {
			sidebarVisible: r.mode.sidebarVisible,
			sidebarDocked: r.mode.sidebarDocked,
			isMobile: selectIsMobile(r.mode),
		};
	}, shallowEqual);

	const handleClick = () => {
		if (isMobile) {
			// Mobile: toggle sidebarVisible directly
			dispatch(setSidebarVisible(!sidebarVisible));
		} else {
			// Desktop: toggle docked state
			dispatch(setSidebarDocked(!sidebarDocked));
		}
	};

	// Desktop hover handlers (gated by !isMobile)
	const handleMouseEnter = () => {
		if (!isMobile && !sidebarDocked) {
			dispatch(setSidebarHovered(true));
		}
	};

	const handleMouseLeave = () => {
		if (!isMobile && !sidebarDocked) {
			dispatch(setSidebarHovered(false));
		}
	};

	// Show icon based on state: Mobile uses sidebarVisible, Desktop uses sidebarDocked
	const iconState = isMobile ? sidebarVisible : sidebarDocked;

	return (
		<S.Base
			isMobile={isMobile}
			isFloating={isFloating}
			onClick={handleClick}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<Icon
				type={iconState ? IconType.LEFT_PANE_VISIBLE : IconType.LEFT_PANE_HIDDEN}
				width={isMobile ? 28 : 16}
				height={isMobile ? 28 : 16}
				color={theme.gray[1000]}
			/>
		</S.Base>
	);
};

export default SidebarToggle;
